// Awning product catalog — scraped from xpeditionz.co.nz Feb 2026
// Sorted price desc. All prices GST-inc NZD.

export const AWNING_HERO = "/products/awnings/731077_2f0bb32ad8cb4d21b3d2c6e6410e641d~mv2.jpg";
export const AWNING_HERO_MAXX2M = "/products/awnings/731077_aa9875e427f945f3b7a751933aed51db~mv2.jpg";

// Video URL for the walk-around. User needs to supply the YouTube (or similar) link.
// If null, the video section shows a placeholder card.
export const AWNING_WALKAROUND_VIDEO = "https://www.youtube.com/watch?v=i5mV0RuHqVY";

export const AWNING_MODELS = [
  {
    slug: "quick-pitch-weathershade-maxx",
    name: "Quick Pitch Weathershade MAXX",
    brand: "Quick Pitch",
    type: "awning",
    price: 2795,
    tagline: "Larger Vehicles · 270° Coverage",
    thumb: "/products/awnings/731077_783d72174df043d28d6bba803b70ab82~mv2.jpg",
    gallery: [
      "/products/awnings/731077_783d72174df043d28d6bba803b70ab82~mv2.jpg",
      "/products/awnings/731077_b7cd9c7717884cc491e09149def27bec~mv2.jpg",
      "/products/awnings/731077_adac8684d5ac440fb6041fae425abc64~mv2.jpg",
      "/products/awnings/731077_c0a6a68844814b5c902a0e527786536c~mv2.jpg",
      "/products/awnings/731077_33dd16afaefb423b888b43d251714b88~mv2.jpg",
      "/products/awnings/731077_761af472d9d7413084476cef7cb7d976~mv2.jpg",
      "/products/awnings/731077_ceca6e9a8ebc4009b43736cf0ecd0407~mv2.jpg",
      "/products/awnings/731077_96d85e91aabf4b80b6cf96c8bfaa6876~mv2.jpg",
      "/products/awnings/731077_7c313cffdd5b4a348e6db39748d481b6~mv2.jpg",
      "/products/awnings/731077_2dc617de9e2541219551b2f04d96e534~mv2.jpg",
      "/products/awnings/731077_3b9e3f394d624d6b913954737dfddb1a~mv2.jpg",
    ],
    intro: "The MAXX freestanding-capable 270° awning — sized for larger vehicles. Advanced aluminised technical canvas reflects heat and UV for a noticeably cooler shelter. Genuine 400gsm South African polycotton wall kits available.",
    features: [
      "270° coverage — deploys around three sides of your vehicle",
      "Aluminised technical canvas — reflects radiant heat + UV, deeper shade",
      "Freestanding capable — no vehicle contact needed once set up",
      "Wind-rated frame construction",
      "Compatible with 400gsm South African polycotton wall kits (sold separately)",
      "Sized for larger 4WDs and touring vehicles",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "quick-pitch-180-xl-caravans",
    name: "Quick Pitch 180° XL Awning",
    brand: "Quick Pitch",
    type: "awning",
    price: 2490,
    tagline: "For Caravans & Motorhomes",
    thumb: "/products/awnings/731077_8d74a7fc05894f4c8f20a227a7f4e135~mv2.jpg",
    gallery: [
      "/products/awnings/731077_8d74a7fc05894f4c8f20a227a7f4e135~mv2.jpg",
      "/products/awnings/731077_1a415cdb44464a1eb8d78ed036197b7d~mv2.jpeg",
    ],
    intro: "Larger 180° awning designed for caravans, motorhomes and larger touring vehicles. Same premium South African aluminised technical canvas as the rest of the Quick Pitch range.",
    features: [
      "180° coverage — extends out the side of the vehicle",
      "3m extended length — ideal for caravans/motorhomes",
      "Aluminised technical canvas construction",
      "Robust frame engineered for real weather",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "quick-pitch-weathershade-maxx-2m",
    name: "Quick Pitch Weathershade 270 MAXX 2M",
    brand: "Quick Pitch",
    type: "awning",
    price: 2299,
    tagline: "Maxx 2m 270° Layout — Alternate Shape",
    thumb: "/products/awnings/731077_aa9875e427f945f3b7a751933aed51db~mv2.jpg",
    gallery: [
      "/products/awnings/731077_850f63f2ccbe48e7b44885e1bedde22e~mv2.jpg",
      "/products/awnings/731077_aa9875e427f945f3b7a751933aed51db~mv2.jpg",
      "/products/awnings/731077_265bc7fc6baa4139a6637c7f1f6df0c2~mv2.jpg",
      "/products/awnings/731077_df82a20bf307464e9e89047060ef15cb~mv2.png",
      "/products/awnings/731077_57a19dae068d46cd867bedb2d8b81b14~mv2.png",
      "/products/awnings/731077_6735cfa0f4704e7b8217c55c215e02f6~mv2.jpg",
      "/products/awnings/731077_8fcef9f330214f8197c281b9e4abc34a~mv2.jpeg",
      "/products/awnings/731077_40a2145eedcd44029c7863ec7bcc652b~mv2.jpg",
      "/products/awnings/731077_ba652a8179824d83a3177a4103a0968d~mv2.jpg",
      "/products/awnings/731077_7271f555ebfd4a1288fd76474f052484~mv2.jpg",
      "/products/awnings/731077_319c8b307fde4dedb3d2487ea7f63b44~mv2.jpg",
    ],
    intro: "The 2-metre MAXX 270° layout — an alternate awning shape offered by Quick Pitch alongside the Regular 270°. Different footprint, same aluminised technical canvas, same freestanding-capable design. Pick the shape that suits your vehicle and how you camp.",
    features: [
      "270° coverage in the Maxx 2m layout",
      "Aluminised technical canvas — reflects heat and UV",
      "Naturally light-blocking — deeper shade, less glare",
      "Freestanding capable — no vehicle contact once deployed",
      "Compatible with 400gsm SA polycotton wall kits",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "quick-pitch-weathershade-20sec",
    name: "Quick Pitch Weathershade 20 Sec 270°",
    brand: "Quick Pitch",
    type: "awning",
    price: 2199,
    priceFrom: true,
    optionGroups: [
      { key: "fitment", label: "Fitment", required: true, choices: [{ label: "Left Side", priceDelta: 0 }, { label: "Right Side", priceDelta: 0 }] },
      { key: "hatch", label: "Tent Access Hatch", required: true, choices: [{ label: "No - Standard Awning", priceDelta: 0 }, { label: "Yes - with Tent Access Hatch", priceDelta: 0 }] },
    ],
    tagline: "Regular 270° Layout · 20-Second Deployment",
    thumb: "/products/awnings/731077_2f0bb32ad8cb4d21b3d2c6e6410e641d~mv2.jpg",
    gallery: [
      "/products/awnings/731077_2f0bb32ad8cb4d21b3d2c6e6410e641d~mv2.jpg",
      "/products/awnings/731077_66548ea4ca0a41ce8c03d65ab5047bd7~mv2.png",
      "/products/awnings/731077_40def27d02e94edebd12e5742ab22f67~mv2.png",
      "/products/awnings/731077_befd8c4d05774f1e85a4af855fc026a8~mv2.png",
      "/products/awnings/731077_df82a20bf307464e9e89047060ef15cb~mv2.png",
      "/products/awnings/731077_57a19dae068d46cd867bedb2d8b81b14~mv2.png",
      "/products/awnings/731077_f8c6ceaf419644f28261b5453d6e0870~mv2.jpg",
      "/products/awnings/731077_6bf95a84056445318a347526d25850da~mv2.jpg",
      "/products/awnings/731077_4fb9b6847b3f4ffcbb81674755d94348~mv2.jpg",
      "/products/awnings/731077_7a70a49a199249eca3568c8cd357f52f~mv2.jpg",
      "/products/awnings/731077_e194d39ca19d4902bad726465f48b792~mv2.jpg",
      "/products/awnings/731077_bcd0ce174d6b4fcb9b31f99a549c89f9~mv2.jpg",
      "/products/awnings/731077_89a7183b35a74ad0b55ae1bdec154875~mv2.jpg",
    ],
    intro: "The flagship Quick Pitch 270° awning — the regular 270° layout in Xpeditionz's hero image. Deploys in just 20 seconds. Aluminised technical canvas for a noticeably cooler shelter, genuine 400gsm South African polycotton wall kits available.",
    features: [
      "20-second deployment",
      "270° coverage — regular layout",
      "Aluminised technical canvas — reflects heat + UV",
      "Naturally light-blocking canvas — deeper shade",
      "Freestanding-capable — no vehicle contact once set up",
      "Compatible with 400gsm SA polycotton wall kits (sold separately)",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "quick-pitch-weathershade-2m",
    name: "Quick Pitch Weathershade 2.0m",
    brand: "Quick Pitch",
    type: "awning",
    price: 1999,
    tagline: "For Smaller Vehicles",
    thumb: "/products/awnings/731077_fc31117558754a3b8f870e1803f7b1b1~mv2.jpg",
    gallery: [
      "/products/awnings/731077_731963ea5a804b0f99b0aa8e2282559a~mv2.jpg",
      "/products/awnings/731077_fc31117558754a3b8f870e1803f7b1b1~mv2.jpg",
      "/products/awnings/731077_cc14d4d373524b83a99c4259b88a9837~mv2.jpeg",
      "/products/awnings/731077_61ccf50340224e5790ea8fb0badfd123~mv2.jpg",
      "/products/awnings/731077_f1e3f43a2c6f4fafbd4f5a9736188d5d~mv2.jpg",
      "/products/awnings/731077_a423cde47e4d48c1933dd2e109365ab9~mv2.jpg",
      "/products/awnings/731077_e5a9d995569b492f85be8bf15122a24c~mv2.jpg",
      "/products/awnings/731077_c2b471acdd704c31921cfcceac32619f~mv2.jpg",
      "/products/awnings/731077_da461f7403734b9c9a3d4d7e83b91aa2~mv2.jpg",
    ],
    intro: "The 2.0m variant sized for smaller vehicles — utes without canopies, wagons, and lighter 4WDs. Same premium Quick Pitch aluminised canvas construction in a more compact package.",
    features: [
      "2.0m version — compact for smaller vehicles",
      "Aluminised technical canvas",
      "Retains the fast setup + freestanding capability",
      "Ideal for smaller 4WDs and wagons",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "quick-pitch-weathershade-180",
    name: "Quick Pitch Weathershade 180°",
    brand: "Quick Pitch",
    type: "awning",
    price: 1799,
    optionGroups: [
      { key: "fitment", label: "Fitment", required: true, choices: [{ label: "Left Side", priceDelta: 0 }, { label: "Right Side", priceDelta: 0 }] },
    ],
    tagline: "Regular 180° Awning",
    thumb: "/products/awnings/731077_e72635231c484e8483732db1c97c8f0c~mv2.jpeg",
    gallery: [
      "/products/awnings/731077_e72635231c484e8483732db1c97c8f0c~mv2.jpeg",
      "/products/awnings/731077_3839ba91983f44bcacd18781ab573f96~mv2.jpeg",
      "/products/awnings/731077_3644f2c30444413f9c715ef6e558baa0~mv2.jpeg",
      "/products/awnings/731077_b7b27b2f875648e88f964b3e7a036032~mv2.jpeg",
      "/products/awnings/731077_16674c5ab24e47e8b86358e78c6d148e~mv2.png",
    ],
    intro: "The standard Quick Pitch 180° side-out awning. Simpler installation than the 270°, still with the same premium South African aluminised canvas and robust frame.",
    features: [
      "180° coverage — extends out one side",
      "Aluminised technical canvas",
      "Wind-rated frame",
      "Faster/simpler setup than 270° designs",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "eezi-awn-dragonfly-180",
    name: "EEZI-AWN DragonFly 180",
    brand: "EEZI-AWN",
    type: "awning",
    price: 1675,
    priceWas: 1875,
    tagline: "South African Canvas · Grey",
    thumb: "/products/awnings/731077_5f64e9ce429a41c3a00251d2b6940c6c~mv2.jpg",
    gallery: [
      "/products/awnings/731077_5f64e9ce429a41c3a00251d2b6940c6c~mv2.jpg",
      "/products/awnings/731077_0ce576b2067f45e2ab361f5664e19cbc~mv2.jpg",
      "/products/awnings/731077_6bb96c236d3c43cbb22f1f5b12ea9d79~mv2.jpg",
      "/products/awnings/731077_2a5a84feca134569922ec5355771c7c6~mv2.jpg",
      "/products/awnings/731077_67920dbff979429da6a69ab21ca08263~mv2.jpg",
      "/products/awnings/731077_3df06a8df22349939080a5199803eb89~mv2.jpg",
      "/products/awnings/731077_971a1c336a00446ca879199c8ef00bb4~mv2.jpg",
      "/products/awnings/731077_738baf7bc4824cd39e15fd2a3ec4d50c~mv2.jpg",
      "/products/awnings/731077_52e332a154f4401c8f4202870588b7d1~mv2.jpg",
      "/products/awnings/731077_67c3bfd8e9db4ac6a3ff8ebc76f0e2eb~mv2.jpg",
      "/products/awnings/731077_61a7ff7222b54557a0a9e72a0bd53cdb~mv2.webp",
    ],
    intro: "EEZI-AWN's full-size 180° awning in grey South African polycotton canvas. Made by the same 40-year South African brand behind the Series 3 and Blade — proper canvas, not polyester.",
    features: [
      "Full-size 180° coverage",
      "Real South African polycotton canvas — grey",
      "EEZI-AWN 40-year build quality",
      "Compatible with K9 rack mounting",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "eezi-awn-bat270",
    name: "EEZI-AWN BAT270",
    brand: "EEZI-AWN",
    type: "awning",
    price: 1499,
    priceWas: 1799,
    tagline: "270° · Grey South African Canvas",
    thumb: "/products/awnings/731077_ce5fddc0ee13473d99e02b6fd237de6c~mv2.jpg",
    gallery: [
      "/products/awnings/731077_ce5fddc0ee13473d99e02b6fd237de6c~mv2.jpg",
      "/products/awnings/731077_87a2abe6f8ca4cd59a2e6a7f78c19d0e~mv2.jpg",
      "/products/awnings/731077_76305309d703413385d3cf9bb767d556~mv2.jpg",
      "/products/awnings/731077_9db58530b7784b54a1db1343274eed23~mv2.jpg",
      "/products/awnings/731077_3dd53c8536854cfbb4fd29f684757625~mv2.jpg",
      "/products/awnings/731077_d3aa9747c877418ab674bd30918736bd~mv2.jpg",
      "/products/awnings/731077_1fcd6cc6d06e4085b5abcba71194b6c8~mv2.jpg",
      "/products/awnings/731077_dbe9d92bfe0945b28222dac653e57846~mv2.jpg",
      "/products/awnings/731077_3349a16c7e144d2c99dfbf184c15048f~mv2.jpg",
      "/products/awnings/731077_0eb21e5e13a0461dacbdd92923c1f266~mv2.jpg",
    ],
    intro: "EEZI-AWN's 270° 'BAT' awning in grey — a highly capable 270° system from the world's original 40-year expedition awning brand. Currently on Easter Sale.",
    features: [
      "270° coverage around the vehicle",
      "Genuine South African grey canvas",
      "EEZI-AWN legendary durability",
      "Optional canvas wall kit available (BAT270-specific)",
    ],
    specs: [],
    availability: "On sale",
  },
  {
    slug: "eezi-awn-dragonfly-mini",
    name: "EEZI-AWN DragonFly Mini 180",
    brand: "EEZI-AWN",
    type: "awning",
    price: 1399,
    tagline: "Compact 180° · Grey Canvas",
    thumb: "/products/awnings/731077_43edde82d3bb4d4895b23816feeb5c74~mv2.jpg",
    gallery: [
      "/products/awnings/731077_43edde82d3bb4d4895b23816feeb5c74~mv2.jpg",
      "/products/awnings/731077_0003f8ffb3ee4dfd97c378c15d1388f0~mv2.jpg",
      "/products/awnings/731077_fe6c05d94b434c7ebe258b5f0f9fe8f8~mv2.jpg",
      "/products/awnings/731077_7dcfb9d3874b4e30a1d9c300c89c5d3f~mv2.jpg",
      "/products/awnings/731077_79070a10f79f4e389f8e50018de93ca3~mv2.jpg",
      "/products/awnings/731077_30fd3f8c3fef4462a9a6ce124b2ca90e~mv2.jpg",
      "/products/awnings/731077_bf8ed38e9f7c4e4fa777cf3a8b886417~mv2.jpg",
      "/products/awnings/731077_fa1e750306354490913fdf3a32d4e0a7~mv2.jpg",
      "/products/awnings/731077_c9e04a9d42e44f19a3e1ec66d7c261e0~mv2.jpg",
      "/products/awnings/731077_6b416622a9d04f99aa5e3512f59775a8~mv2.jpg",
      "/products/awnings/731077_ec137b798c1f4a94a921089535e0d70f~mv2.jpg",
      "/products/awnings/731077_e0527df219594f0b920e8f25ca99eb77~mv2.jpg",
      "/products/awnings/731077_dac24d0a08694ba6b3c50733224e12fc~mv2.jpg",
      "/products/awnings/731077_3907806180154098b8c7fd7acf8f6750~mv2.webp",
    ],
    intro: "The compact DragonFly Mini — same EEZI-AWN 40-year build quality in a smaller footprint. Ideal for lighter vehicles, roof-tent-and-awning combos, or where roof-load matters.",
    features: [
      "Compact 180° format",
      "Grey South African polycotton canvas",
      "Lighter than full-size DragonFly",
      "Great pairing with soft-shell roof tents",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "eezi-awn-swift",
    name: "EEZI-AWN Swift",
    brand: "EEZI-AWN",
    type: "awning",
    price: 949,
    tagline: "Freestanding-Capable · Best Value EEZI-AWN",
    thumb: "/products/awnings/731077_92b179edce874f218e46e92f2a3ac8e4~mv2.jpg",
    gallery: [
      "/products/awnings/731077_92b179edce874f218e46e92f2a3ac8e4~mv2.jpg",
      "/products/awnings/731077_ef8b4acf656341aea75ecbe73751f286~mv2.jpg",
      "/products/awnings/731077_64351fbeae254464a8f1079dc1ffa509~mv2.jpg",
      "/products/awnings/731077_0467464d2b024f7694026223f3726e94~mv2.jpg",
      "/products/awnings/731077_54a60b2f86f54d3a86f824f7659f6613~mv2.jpg",
      "/products/awnings/731077_b82e6cd1a5e14b7284405d9826ad3d85~mv2.jpg",
      "/products/awnings/731077_646e5e3632fb4e8181b11edbaf69b3b5~mv2.jpg",
      "/products/awnings/731077_fe61dc2b61db4e2bb792e737dd2348e1~mv2.jpg",
      "/products/awnings/731077_a6fd0798c871477cbcfbbf7e038b1b76~mv2.jpg",
      "/products/awnings/731077_90fa441a6f2e49f882d5bcb9ee4482c0~mv2.jpeg",
    ],
    intro: "EEZI-AWN's entry-price awning — Swift. Freestanding capable and pairs perfectly with the Series 3 or Xklusive T-Top roof tents. Outstanding value from a 40-year world brand.",
    features: [
      "Freestanding-capable design",
      "Simple rapid setup",
      "Pairs perfectly with EEZI-AWN soft-shell roof tents",
      "Best entry point into the EEZI-AWN awning range",
    ],
    specs: [],
    availability: "In stock",
  },
];

export const AWNING_ACCESSORIES = [
  {
    slug: "canvas-wall-kit-bat270",
    inStock: false,
    name: "Canvas Wall Kit for BAT270",
    brand: "EEZI-AWN",
    type: "accessory",
    price: 1695,
    tagline: "South African Canvas · BAT270 Specific",
    thumb: "/products/awnings/731077_5e53088807b341da9f5bf473cd0100bc~mv2.jpg",
    gallery: [
      "/products/awnings/731077_5e53088807b341da9f5bf473cd0100bc~mv2.jpg",
      "/products/awnings/731077_36dec16934d34d559a7c3a8b86c39ada~mv2.jpg",
      "/products/awnings/731077_73c129fe890f4202838f106fb339415b~mv2.jpg",
      "/products/awnings/731077_7534f676dd1046fa8a105a5d97ad10bd~mv2.jpg",
      "/products/awnings/731077_8b2ca3fc967a4339a648f35fa8dd8bd7~mv2.jpg",
      "/products/awnings/731077_c3bea3f464904c48ae8916a97f18c4b4~mv2.jpg",
      "/products/awnings/731077_4600a9d36d03480b93392f70a3940685~mv2.jpg",
    ],
    intro: "Genuine South African polycotton canvas wall kit made specifically for the EEZI-AWN BAT270. Transforms the open 270° awning into a fully enclosed shelter.",
    features: ["Real South African polycotton canvas", "Fitted specifically to BAT270", "Enclosed shelter for extended stays"],
    specs: [],
    availability: "Reserve one",
  },
  {
    slug: "canvas-wall-kit-swift",
    inStock: false,
    name: "Canvas Wall Kit for EEZI-AWN Swift",
    brand: "EEZI-AWN",
    type: "accessory",
    price: 1295,
    tagline: "Grey Canvas · Custom Height Special Order",
    thumb: "/products/awnings/731077_8014d5f2526647f7a37bdf1f8b02e7b1~mv2.jpg",
    gallery: [
      "/products/awnings/731077_8014d5f2526647f7a37bdf1f8b02e7b1~mv2.jpg",
      "/products/awnings/731077_118c9b2fd9d44b1883912ad6888c5709~mv2.jpg",
      "/products/awnings/731077_fba6363677c14abe9abfb4308507458e~mv2.jpg",
      "/products/awnings/731077_d0f3155492924fe494c36821cf9ef183~mv2.jpg",
      "/products/awnings/731077_b4f0fcaeb02144119ff75cd66a4a27d4~mv2.jpg",
      "/products/awnings/731077_5329084aece3474090a37185f1d664b1~mv2.jpg",
      "/products/awnings/731077_6bf8f610af7646eda335fe565ea08b3e~mv2.jpg",
    ],
    intro: "Custom-height canvas wall kit for the EEZI-AWN Swift awning — grey South African polycotton canvas. Special order, choose your ideal wall height.",
    features: ["Grey SA polycotton canvas", "Custom height special order", "Fits EEZI-AWN Swift awning"],
    specs: [],
    availability: "Special order — enquire",
  },
  {
    slug: "wall-kit-quick-pitch",
    name: "Wall Kits for Quick Pitch Awnings",
    brand: "Quick Pitch",
    type: "accessory",
    price: 849,
    priceFrom: true,
    optionGroups: [
      { key: "fitment", label: "Fitment", required: true, choices: [{ label: "Left Side", priceDelta: 0 }, { label: "Right Side", priceDelta: 0 }] },
      { key: "coverage", label: "Full or Partial Wall Kit", required: true, choices: [{ label: "2 Panel Kit", priceDelta: 0 }, { label: "Full Kit", priceDelta: 946 }] },
    ],
    tagline: "400gsm South African Polycotton",
    thumb: "/products/awnings/731077_868fac2a163a4b60b81d5d36d2b76161~mv2.jpg",
    gallery: [
      "/products/awnings/731077_868fac2a163a4b60b81d5d36d2b76161~mv2.jpg",
      "/products/awnings/731077_007404740e5d401b9350c7dce9eb272d~mv2.jpg",
      "/products/awnings/731077_61f42509f32c492b9df1ded1928acedb~mv2.jpg",
      "/products/awnings/731077_4559342855ce49639f256dffb6b6523f~mv2.png",
      "/products/awnings/731077_823ecf01c0fb43e0a5a5ac35ee0fd468~mv2.png",
      "/products/awnings/731077_9a52d4d4dd2e42d39ff64a81e797c228~mv2.png",
      "/products/awnings/731077_d1a4ee5fa4814a5eb2567dc0d6fb48ca~mv2.jpg",
      "/products/awnings/731077_2038efa2ef5548d5a8da39b12c262977~mv2.jpg",
      "/products/awnings/731077_63d176990cb149e996a5a523591c3a90~mv2.jpg",
      "/products/awnings/731077_ea523ceb665847ac88b0de7cb461a0c0~mv2.jpg",
      "/products/awnings/731077_8ce71197efc34570b3bb3eca49fde5fa~mv2.jpg",
      "/products/awnings/731077_39cbc54ce00b4bb1ab405882f1d3a668~mv2.jpg",
      "/products/awnings/731077_137456758cbb47c6b7439222e21f6645~mv2.jpg",
    ],
    intro: "Genuine 400gsm South African polycotton wall kits for Quick Pitch Weathershade awnings. Turn any 270° awning into a completely enclosed shelter with wind flaps and windows.",
    features: [
      "400gsm South African polycotton canvas — proper expedition-grade",
      "Sized to suit different Quick Pitch models",
      "Storm flaps, windows and mesh panels",
    ],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "led-light-kit-quick-pitch",
    name: "LED Light Kit for Quick Pitch Awnings",
    brand: "Quick Pitch",
    type: "accessory",
    price: 279,
    tagline: "Under-Awning Lighting",
    thumb: "/products/awnings/731077_4a559f2576844b49b97dcc861cf6e823~mv2.jpg",
    gallery: [
      "/products/awnings/731077_4a559f2576844b49b97dcc861cf6e823~mv2.jpg",
      "/products/awnings/731077_56ea1a6cf7704240b0f41705bdd61868~mv2.jpg",
      "/products/awnings/731077_423ea0f126ab4993bc7c3ab40cb644f8~mv2.jpg",
      "/products/awnings/731077_9371dccb5578487c81da6c1a92053efe~mv2.jpg",
    ],
    intro: "Purpose-built LED lighting kit that clips directly to Quick Pitch awning frames. Warm and cool colour options.",
    features: ["Fits Quick Pitch awning frames", "Multiple colour modes", "12V power"],
    specs: [],
    availability: "In stock",
  },
  {
    slug: "rain-gutter-quick-pitch",
    name: "Rain Gutter Kit for Quick Pitch",
    brand: "Quick Pitch",
    type: "accessory",
    price: 149,
    tagline: "Channel Rain Away From Awning Edge",
    thumb: "/products/awnings/731077_bf93cd66ec0c40778c3caf511ac68d15~mv2.jpg",
    gallery: [
      "/products/awnings/731077_bf93cd66ec0c40778c3caf511ac68d15~mv2.jpg",
      "/products/awnings/731077_b24f49bc255a49e3a311e7330fe86435~mv2.jpg",
      "/products/awnings/731077_459716cd4f324cefa803c7d3bbe4e497~mv2.jpg",
    ],
    intro: "Simple rain gutter accessory that clips into the edge of a Quick Pitch awning to channel rainwater away from your seating area or wall kit entrance.",
    features: ["Universal Quick Pitch awning fit", "Directs rain away from entrance/seating area"],
    specs: [],
    availability: "In stock",
  },
];

export const ALL_AWNINGS = [...AWNING_MODELS, ...AWNING_ACCESSORIES];
export const findAwning = (slug) => ALL_AWNINGS.find((a) => a.slug === slug);
